var SessionID = require('session/session-id');
var Codec = require('io/codec');

var serialiser = {
    read : function(input) {
        var server = Codec.readInt64(input);
        var value = Codec.readInt64(input);

        return new SessionID(server, value);
    },
    write : function(output, sessionID) {
        Codec.writeInt64(output, sessionID.server);
        Codec.writeInt64(output, sessionID.value);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/session/session-id-serialiser.js
// module id = 108
// module chunks = 0